/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.Employee {
    function fetchWithAuthentication(url, authToken) {
        const headers = new Headers();
        headers.set('Authorization', `Bearer ${authToken}`);
        return fetch(url, { headers });
    }

    async function displayProtectedImage(
        imageId, imageUrl, authToken
    ) {
        const response = await fetchWithAuthentication(
            imageUrl, authToken
        );
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const imageElement = document.getElementById(imageId);
        (<HTMLImageElement>imageElement).src = objectUrl;
    }

    class EmpTwoFactorModalController {

        static $inject = [
            '$mdDialog',
            '$http',
            '$translate',
            '$rootScope',
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            "meevo.components.busy.BusyService",
            "meevo.components.common.IdentityService",
        ];

        public headerText: string;
        public userId: string;
        public mfaCode: string;
        public isMfaEnabled: boolean;
        public error: string = null;

        constructor(
            protected $mdDialog: ng.material.IDialogService,
            protected $http: angular.IHttpService,
            protected $translate: angular.translate.ITranslateService,
            protected $rootScope: angular.IRootScopeService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.BusyService,
            protected identityService: Meevo.Components.Common.IIdentityService) {
   
            const token = window['bearerToken'] || sessionStorage.getItem('mil:meevo:token');
            if (!this.isMfaEnabled) {
                displayProtectedImage('mfaQr', `api/Auth/Mfa/QrCode/${this.userId}`, token).then(res => { });
            }
            if (this.isMfaEnabled && this.identityService.current().fullAccess) {
                this.disable();
            }
        }

        public verify(): void {
            this.error = null;
            this.mfaCode = this.mfaCode ? this.mfaCode.replace(/[-\s]/g, "") : this.mfaCode;
            this.busyService.start();
            const url = `api/Auth/Mfa/${this.userId}/verify/${this.mfaCode}`;
            this.dataService.customMethodData(url, 'GET', {}).then(resp => {
                if (resp.data.success) {
                    this.$mdDialog.hide({ isMfaEnabled: true, entityVersion: resp.data.entityVersion });
                } else {
                    this.error = 'Invalid or expired code.';
                }
            }).finally(() => {
                this.busyService.stop();
            });
        }

        public disable(): void {
            this.error = null;
            this.mfaCode = this.mfaCode ? this.mfaCode.replace(/[-\s]/g, "") : this.mfaCode;
            this.busyService.start();
            const url = `api/Auth/Mfa/${this.userId}/disable/${this.mfaCode}`;
            this.dataService.customMethodData(url, 'GET', {}).then(resp => {
                if (resp.data.success) {
                    this.$mdDialog.hide({ isMfaEnabled: false, entityVersion: resp.data.entityVersion });
                } else {
                    this.error = 'Invalid or expired code.';
                }
            }).finally(() => {
                this.busyService.stop();
            });
        }

        public cancelModal(): void {
            this.$mdDialog.cancel(this.isMfaEnabled);
        }
    }

    angular.module('meevo')
        .controller('meevo.components.empTwoFactorModal.EmpTwoFactorModalController', EmpTwoFactorModalController);
}
